import { render, staticRenderFns } from "./ReactivationExclusions.vue?vue&type=template&id=28dc2467&scoped=true&"
import script from "./ReactivationExclusions.vue?vue&type=script&lang=ts&"
export * from "./ReactivationExclusions.vue?vue&type=script&lang=ts&"
import style0 from "./ReactivationExclusions.vue?vue&type=style&index=0&id=28dc2467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dc2467",
  null
  
)

export default component.exports